module.exports = __webpack_public_path__ + "UniversityOfMontana_white400x75-9f8d7f7d7af4e8c6a51df9c2cdeac31d.png";